// extracted by mini-css-extract-plugin
export var quillEditor = "_oi-1";
export var variable = "_oi-0";